// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html {\n    visibility: visible;\n    opacity: 1;\n}", ""]);
// Exports
module.exports = exports;
